import classNames from "classnames";
import { FieldMetaProps } from "formik";
import React, { PropsWithChildren } from "react";

export type InputContainerVariant = "default" | "sectioned";

export type InputContainerProps = {
  additionalClassName?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meta: FieldMetaProps<any>;
  variant?: InputContainerVariant;
};

const InputContainer = (props: PropsWithChildren<InputContainerProps>) => {
  const { children, additionalClassName = "", meta, variant = "default" } = props;

  return (
    <div
      className={classNames(additionalClassName, "relative mb-6 lg:mb-10", {
        "pt-6 lg:pt-10 first-of-type:pt-0 border-t first-of-type:border-t-0 border-form-section-border":
          variant === "sectioned"
      })}
    >
      <div className="relative w-full">{children}</div>

      {meta.touched && meta.error && (
        <div className="absolute bottom-0 -mb-6 text-sm text-brand-tertiary-50">
          {meta.error}
        </div>
      )}
    </div>
  );
};

export default InputContainer;
